import styled from 'styled-components';

const Bar = styled.div`
  width: 100%;
  background: #b8860b;
  color: #fff;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  font-size: 13px;
  flex-wrap: wrap;
  text-align: center;
`;

const ReturnButton = styled.button`
  background: #fff;
  color: #b8860b;
  border: none;
  border-radius: 4px;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`;

const ImpersonationBannerStyled = {
  Bar,
  ReturnButton,
};

export default ImpersonationBannerStyled;
